import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { App } from 'src/app/env/app/interfaces/app.interface';
import { AuthService } from 'src/app/env/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { FileGA } from '../interfaces/file_ga.interface';
import { GAFile } from '../interfaces/ga/file-data.interface';
import { GAFileResponse } from '../interfaces/ga/file-response';


@Injectable({
  providedIn: 'root'
})

export class GAServices {

  constructor(private http:HttpClient,
              private session:AuthService
              ) { }



  downloadPost(filter:any):Observable<FileGA>{
    let path = window.location.pathname + window.location.search + window.location.hash;

    if (path.charAt(0) === '/') {
      path = path.substring(1);
    }

    path=path.split("/")[0]

    const data={
            app:path,
            filter:filter
          }

    return this.http.post<FileGA>(`${environment.apiBase}/ga/v1/descargar/`,data);
  }

  download(data:any){
    this.downloadPost(data).subscribe(
        resp=>{
          
            const byteCharacters = atob(resp.base64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/octet-stream' });

            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = resp.originial_name+"."+(resp.file_type).toLocaleLowerCase(); // Establece el nombre del archivo aquí
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);


        }
    )
  }

  upload(gaFila:GAFile[]){
    return this.http.post<GAFileResponse[]>(`${environment.apiBase}/ga/v1/upload/`,{files:gaFila});
  }

}
